(function () {
  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function tick() {
    var roots = document.querySelectorAll('[data-rl-bf-end]');
    roots.forEach(function (root) {
      var end = new Date(root.getAttribute('data-rl-bf-end')).getTime();
      if (isNaN(end)) return;
      var now = Date.now();
      var totalSeconds = Math.max(0, Math.floor((end - now) / 1000));

      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var textEls = root.querySelectorAll('[data-rl-bf-text]');
      textEls.forEach(function (textEl) {
        textEl.textContent = pad(days) + 'D ' + pad(hours) + 'H ' + pad(minutes) + 'M ' + pad(seconds) + 'S';
      });

      var parts = { days: days, hours: hours, minutes: minutes, seconds: seconds };
      Object.keys(parts).forEach(function (key) {
        var el = root.querySelector('[data-rl-bf-' + key + ']');
        if (el) el.textContent = pad(parts[key]);
      });

      if (totalSeconds <= 0 && root.hasAttribute('data-rl-bf-hide-at-zero')) {
        root.style.display = 'none';
      }
    });
  }

  tick();
  setInterval(tick, 1000);
})();
